import styles from "./TourListHeader.module.css";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from "react-router-dom";
import { MdAdd } from "react-icons/md";

const TourListHeader = (props) => {
    const { text, description, showCreateTour=true } = props;
    return (
        <div className={styles.tourListHeader}>
            <Row className="align-items-center">
                <Col md={9} sm={12}>
                    <div>
                        <h1>{ text }</h1>
                        <p>
                            { description }
                        </p>
                    </div>
                </Col>
                { showCreateTour ? <Col md={3} sm={12}>
                    <Link to="/create-tour/tour-info">
                        <Button variant="warning" size="lg" className={styles.createTourBtn}>
                            <span className={styles.btnText}>Create Tour</span>
                            <MdAdd className={styles.btnIcon} />
                        </Button>
                    </Link>
                </Col> : null}
            </Row>
        </div>
    );
};

export default TourListHeader;